import getImagePath from "shared/util/getImagePath";

/*
 * Util functions for photos.
 * @namespace
 */
export default {
	/*
	 * Get a placeholder image.
	 * @param  {string} size - What size image would you like?
	 * @return {string} - The placeholder image url
	 */
	getPlaceholder(size) {
		return `${getImagePath()}media/img/user/placeholder_2013/pq_${size}.png`;
	},
};



// WEBPACK FOOTER //
// ./src/shared/util/PhotoUtil.js